import { render, staticRenderFns } from "./ApplicationsCoursesUpdateModal.vue?vue&type=template&id=67b4b378&scoped=true&"
import script from "./ApplicationsCoursesUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./ApplicationsCoursesUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationsCoursesUpdateModal.vue?vue&type=style&index=0&id=67b4b378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4b378",
  null
  
)

export default component.exports